import React from 'react';
import { Close24 } from '@carbon/icons-react';
import {
  getAvatarColorsArray,
  getRandomColor,
} from 'app/components/Core/ChakraAvatar/utils';
import {
  Button,
  Flex,
  Text,
  Theme,
  useMultiStyleConfig,
  useTheme,
} from '@chakra-ui/react';
import { ChakraAvatar } from 'app/components/Core';
import { AvatarColors } from 'types/profile';

export interface UserInfoCardProps {
  user: {
    initials: string;
    displayName: string;
    avatar?: string;
    avatarColors?: AvatarColors;
  };
  disableClose?: boolean;
  onClose: () => void;
}

export const UserInfoCard: React.FC<UserInfoCardProps> = ({
  user: { initials, displayName, avatar, avatarColors },
  onClose,
  disableClose,
}) => {
  const theme = useTheme<Theme>();
  const randomColor = getRandomColor(getAvatarColorsArray(theme), initials);
  const styles = useMultiStyleConfig('UserInfoCard', {});
  return (
    <Flex sx={styles.container} data-testid="user-info-card">
      <ChakraAvatar
        initials={initials}
        src={avatar}
        size="sm"
        colors={
          avatarColors || {
            background: randomColor[200],
            text: randomColor[500],
          }
        }
        data-testid="initials"
      />
      <Text as="h6" sx={styles.header} title={displayName}>
        {displayName}
      </Text>
      {!disableClose && (
        <Button
          aria-label="Remove card"
          onClick={onClose}
          size="large"
          marginLeft="auto"
          variant="text"
        >
          <Close24 color="var(--chakra-colors-iconBase)" />
        </Button>
      )}
    </Flex>
  );
};
